import {
  FontAwesomeIcon,
  type FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome'

/** Font Awesome solid glyphs, single colour (GXLabs iconography). */
export function Icon(props: FontAwesomeIconProps) {
  return <FontAwesomeIcon fixedWidth aria-hidden {...props} />
}
